module.exports = __webpack_public_path__ + "img/nocommutest.ffa36558.svg";